import $ from 'jquery';
import { MindboxCarousel } from './mindbox-carousel';

export class MindboxCategoryRecommendations {

    constructor() {
        this.container = $('[data-mindbox-product="category"]');
    }

    init() {
        if (this.container.length === 0) {
            return;
        }
        let sectionId = this.container.attr('data-section-id');
        let _self = this;
        $.ajax({
            url: '/ajax/action/widget_mindbox_products/get_category_products/',
            data: {
                sectionId: sectionId
            },
            type: 'GET',
            success: function(result) {
                console.log(result);
                if (result.data.status !== 'ok') {
                    console.log('mindbox box not render');
                    return;
                }

                _self.container.html(result.html);
                MindboxCarousel.init(_self.responsiveOptions());
            }
        });
    }

    responsiveOptions() {
        return {
            0: {
                items: 2,
                dots: true
            },
            481: {
                items: 2,
                dots: true
            },
            768: {
                items: 3,
                nav: true
            },
            992: {
                items: 3,
                nav: true
            },
            1200: {
                items: 5,
                nav: true
            }
        };
    }
}

jQuery(function() {
    new MindboxCategoryRecommendations().init();
});



// WEBPACK FOOTER //
// ./modules/mindbox/mindbox-category-recommendations.js